import { render, staticRenderFns } from "./regModel.vue?vue&type=template&id=fbf69c6a&scoped=true"
import script from "./regModel.vue?vue&type=script&lang=js"
export * from "./regModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf69c6a",
  null
  
)

export default component.exports